import src from "IMAGE";
export default { src, width: 348, height: 160, blurWidth: 0, blurHeight: 0};
